export const NoRowsMessage =
  '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No slides matched.</span>';
